var chunkToChildrenMap = {
	"1322": [
		2364,
		3389,
		6918,
		6788,
		8021,
		3536,
		1049,
		337
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));